<template>
    <span>
        <i class="fas fa-check-square" v-if="value"></i>
        <i class="far fa-square" v-else></i>
    </span>
</template>

<script>
export default {
    props: {
        value: {
            required: true
        }
    }
}
</script>